import React, { useEffect, useState } from "react";

function CounterOfferModal({
  showCounterOfferModal,
  setShowCounterOfferModal,
}) {
  const [counterOffer, setCounterOffer] = useState("");
  const [note, setNote] = useState("");

  // Disable body scroll when modal is open
  useEffect(() => {
    if (showCounterOfferModal) {
      document.body.style.overflow = "hidden";
    }

    // Cleanup function to restore body scroll when modal is closed
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showCounterOfferModal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Counter Offer Submitted:", counterOffer, note);
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-20 transition-opacity duration-300 ${
        showCounterOfferModal ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        className={`w-[50%] flex justify-center items-center p-10 bg-[#F8F8F8] transition-transform duration-500 ease-in-out transform ${
          showCounterOfferModal ? "scale-100" : "scale-95"
        }`}
      >
        <div className="bg-white rounded-sm w-[98%] border border-[#E5E5E5] p-8">
          <h2 className="text-2xl font-semibold mb-2 text-[#035C98] font-poppins">
            Sell Counter Offer
          </h2>
          <p className="mb-4 text-[16px] text-[#777777] font-poppins font-medium">
            Send a counter price offer for Home
          </p>

          <form onSubmit={handleSubmit}>
            {/* Current Market Price and Seller Expected Price in the same row */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm text-gray-700">
                  Current Market Price
                </label>
                <input
                  type="text"
                  value="₹19,4940"
                  className="w-full p-2 mt-2 border border-gray-300 rounded-md bg-gray-100 text-gray-700"
                  disabled
                />
              </div>

              <div>
                <label className="block text-sm text-gray-700">
                  Seller Expected Price
                </label>
                <input
                  type="text"
                  value="₹20,0000"
                  className="w-full p-2 mt-2 border border-gray-300 rounded-md bg-gray-100 text-gray-700"
                  disabled
                />
              </div>
            </div>

            {/* Your Counter Offer */}
            <div className="mb-4">
              <label className="block text-sm text-gray-700">
                Your Counter Offer
              </label>
              <input
                type="number"
                value={counterOffer}
                onChange={(e) => setCounterOffer(e.target.value)}
                className="w-full p-2 mt-2 border border-gray-300 rounded-md text-gray-700"
                placeholder="₹40,0000"
              />
            </div>

            {/* Note (Optional) */}
            <div className="mb-4">
              <label className="block text-sm text-gray-700">
                Note (Optional)
              </label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                className="w-full p-2 mt-2 border border-gray-300 rounded-md text-gray-700"
                placeholder="Add more about your counter offer"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-between">
              <button
                type="button"
                className="bg-[#FFFFFF] text-black px-12 border border-[#8C8B91] py-3 rounded-xl font-semibold"
                onClick={() => setShowCounterOfferModal(!showCounterOfferModal)}
              >
                Back
              </button>
              <button
                type="submit"
                className="bg-[#FFB819] text-black px-20 rounded-xl py-3 font-semibold"
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CounterOfferModal;
